module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/cases/a2@2x_52a9946d176f66e064a9514f28014e66.png";